<template>
    <list-search v-bind="{ ...$attrs, showsSearch, loading }" @search="emit">
        <v-row class="ma-n2">
            <v-col cols="6" lg="3" class="pa-2">
                <v-text-field label="기간검색(시작일)" v-model="query['searchDateValue'][0]" type="date" max="2999-12-31" clearable v-bind="attrs_input" />
            </v-col>
            <v-col cols="6" lg="3" class="pa-2">
                <v-text-field label="기간검색(종료일)" v-model="query['searchDateValue'][1]" type="date" max="2999-12-31" clearable v-bind="attrs_input" />
            </v-col>
            <v-col cols="0" lg="6" class="d-none d-lg-block" />
            <v-col cols="6" lg="3" class="pa-2">
                <v-text-field v-model="query['code']" label="부품코드" clearable v-bind="attrs_input" @keydown.enter="emit" />
            </v-col>
            <v-col cols="6" lg="3" class="pa-2">
                <v-text-field v-model="query['name']" label="부품명" clearable v-bind="attrs_input" @keydown.enter="emit" />
            </v-col>
            <v-col cols="6" lg="3" class="pa-2">
                <v-text-field v-model="query['spec']" label="규격" clearable v-bind="attrs_input" @keydown.enter="emit" />
            </v-col>
            <v-col cols="6" lg="3" class="pa-2">
                <v-text-field v-model="query['custName']" label="공급업체" clearable v-bind="attrs_input" @keydown.enter="emit" />
            </v-col>
        </v-row>
    </list-search>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import ListSearch from "@/components/console/dumb/list-search.vue";

let initQuery = (query = {}) => ({
    ...query,

    ["searchDateValue"]: [...(query["searchDateValue"] ?? [null, null])],

    ["code"]: query?.["code"] ?? null,
    ["name"]: query?.["name"] ?? null,
    ["spec"]: query?.["spec"] ?? null,
    ["custName"]: query?.["custName"] ?? null,
});

export default {
    components: {
        ListSearch,
    },
    props: {
        showsSearch: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        query: initQuery(),

        attrs_input,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            const { ...query } = this.query || {};

            delete query.page;

            if (!query["searchDateValue"][0] && !query["searchDateValue"][1]) delete query["searchDateValue"];

            if (!query?.["code"]) delete query["code"];
            if (!query?.["name"]) delete query["name"];
            if (!query?.["spec"]) delete query["spec"];
            if (!query?.["custName"]) delete query["custName"];

            this.$router.push({ query });
        },
    },
};
</script>

<style></style>
